import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ImageGrid from './ImageGrid/ImageGrid';
import styles from './AiImageGeneratorHome.module.css';
import StyledButton from '../../shared_components/StyledButton/StyledButton';
import ImageService from '../../services/ImageService';
import UserData from '../../services/UserData';

function AiImageGeneratorHome() {
	const navigate = useNavigate();
	const [images, setImages] = useState([]);
	const [filteredImages, setFilteredImages] = useState([]);
	const [searchQuery, setSearchQuery] = useState('');
	const [loading, setLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);

	const userData = useContext(UserData);
	const fetchTotalPages = useCallback(() => {
		if (!userData) return;
		ImageService.getTotalPages(userData.jwtToken, userData)
			.then((totalPages) => {
				setTotalPages(totalPages);
			})
			.catch((error) => {});
	}, [userData]);

	const fetchImages = useCallback(
		(page = 1) => {
			if (!userData) return;
			setLoading(true);
			ImageService.getAllImages(userData.jwtToken, userData, page - 1, 6)
				.then((response) => {
					setImages(response.content);
					setFilteredImages(response.content);
					setCurrentPage(page);
				})
				.catch((error) => {})
				.finally(() => {
					setLoading(false);
				});
		},
		[userData]
	);

	useEffect(() => {
		fetchImages(1);
		fetchTotalPages();
	}, [fetchTotalPages, fetchImages]);

	const handleGenerateImageClick = () => {
		navigate('/image/generate', { state: { filteredImages } });
	};

	const handleSearchSubmit = (searchTerm) => {
		setLoading(true);
		setSearchQuery(searchTerm);
		setCurrentPage(1);
		
		Promise.all([
			ImageService.searchImages(userData.jwtToken, userData, searchTerm, 0, 6),
			ImageService.getSearchTotalPages(userData.jwtToken, userData, searchTerm, 6)
		])
			.then(([searchResults, totalPages]) => {
				setFilteredImages(searchResults.content);
				setTotalPages(totalPages);
			})
			.catch((error) => {
				console.error('Search error:', error);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const handlePageChange = (newPage) => {
		if (searchQuery) {
			// Handle search pagination
			setLoading(true);
			ImageService.searchImages(userData.jwtToken, userData, searchQuery, newPage - 1, 6)
				.then((searchResults) => {
					setFilteredImages(searchResults.content);
					setCurrentPage(newPage);
				})
				.catch((error) => {
					console.error('Search pagination error:', error);
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			// Handle regular pagination
			fetchImages(newPage);
		}
	};

	const handleClearSearch = () => {
		setSearchQuery('');
		setCurrentPage(1);
		fetchImages(1);
		fetchTotalPages();
	};

	return (
		<div>
			<div className={styles.centeredButtonContainer}>
				<StyledButton
					className={styles.centeredButton}
					onClick={handleGenerateImageClick}>
					Generate Image
				</StyledButton>
			</div>
			<ImageGrid
				images={images}
				searchQuery={searchQuery}
				handleSearchSubmit={handleSearchSubmit}
				handleClearSearch={handleClearSearch}
				filteredImages={filteredImages}
				setFilteredImages={setFilteredImages}
				loading={loading}
				currentPage={currentPage}
				totalPages={totalPages}
				onPageChange={handlePageChange}
				getImageUrl={(imageId) => `/gallery/image/${imageId}`}
				jwtToken={userData.jwtToken}
				userData={userData}
				setCurrentPage={setCurrentPage}
			/>
		</div>
	);
}

export default AiImageGeneratorHome;
